export default {
  container: {
    padding: '20px',
  },
};
